import './App.css';

import { Navigate, Routes, Route } from "react-router-dom";

// components
import DashboardLayout from "./layout/DashboardLayout";
import ErrorPage from "./pages/404";
import FeedbackPage from './components/FeedbackPage/FeedbackPage';
import { Helmet } from 'react-helmet';
import favicon from './favicon.ico';
import PrivacyPolicy from './components/BottomNavigation/Privacy/Privacy';
import BottomNav from './components/BottomNavigation/BottomNavigation';
import Terms from './components/BottomNavigation/terms/Terms';
import IntroVideoPage from './components/MainVideoPage/IntroVideoPage';
import VideoComponent from './components/MainVideoPage/VideoComponent';
import ReactGA from 'react-ga4';
import { useEffect } from 'react';
import Pdf from './components/pdf/Pdf';
import PodcastComponent from './components/podcasts/PodcastComponent';
import Player from './components/player/Player';
import PodcastPlayer from './components/podcasts/PodcastPlayer';

const TRACKING_ID = "G-9YFHBB8ZR1"; // OUR_TRACKING_ID

const App = () => {

  useEffect(() => {
    ReactGA.initialize(TRACKING_ID, { debug: true });
  }, []);

  return (
    <>
      <DashboardLayout>
        <Routes>
          <Route path="/" exact element={<IntroVideoPage />}/>
          <Route path="/video" exact element={<IntroVideoPage />} />
          <Route path="/video/:id" exact element={<VideoComponent />} />
          <Route path="/video/:id/bookmark/:bk" exact element={<VideoComponent />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/contact" element={<FeedbackPage />} />
          <Route path="/podcasts" exact element={<PodcastComponent />} />
          <Route path="/podcasts" exact element={<PodcastPlayer/>} />
          <Route path="/podcasts/:encodedRssFeed/mp3/:encodedMp3" exact element={<PodcastPlayer />} />
          {/*<Route path="/player" element={<Player />} />
          <Route path="/player/:id" exact element={<Player />} /> **/}
          {/*<Route path="/podcasts/:id/mp3/:mp3/bookmarks/:bookmarks" exact element={<PodcastPlayer />} /> */}
          {/*<Route path="/website" element={<TextExtractor />} /> */}
          {/*<Route path="/pdf" element={<Pdf />} />*/}
          {/*<Route path="/test/:id" exact element={<VideoPage videos={videos} handleDeleteButtonClick={handleDeleteButtonClick} handleVideoClick/>} /> */}
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </DashboardLayout>

      <BottomNav />
    </>

  );
}

export default App;
